import ApprovalNotifications, { useApprovalInbox } from './ApprovalNotifications';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';

// ─── Icons ────────────────────────────────────────────────────────────────────
const Icon = ({ d, d2, className = 'w-5 h-5' }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={d} />
    {d2 && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={d2} />}
  </svg>
);

const icons = {
  dashboard: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
  patients: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z',
  phone: 'M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z',
  users: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z',
  calendar: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2h-1m-6 0H5a2 2 0 00-2 2v12a2 2 0 002 2h4m-6 0h6m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
  centers: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
  customers: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
  billing: 'M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z',
  invoices: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  equipment: 'M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2V9M9 21H5a2 2 0 01-2-2V9m0 0h18',
  reports: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
  settings: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-2.572 1.065c-.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-1.065 2.572c-1.756.426-1.756 2.924 0-3.35a1.724 1.724 0 001.066 2.573c1.756-.426 1.756-2.924 0-3.35a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-.426-1.756-2.924-1.756-3.35 0a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z',
  settings2: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z',
  logout: 'M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1',
  menu: 'M4 6h16M4 12h16M4 18h16',
  chevronLeft: 'M15 19l-7-7 7-7',
  chevronRight: 'M9 5l7 7-7 7',
  chevronDown: 'M19 9l-7 7-7-7',
  chevronUp: 'M5 15l7-7 7 7',
  search: 'M21 21l-4.35-4.35m1.1-5.4a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z',
  bell: 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9',
  close: 'M6 18L18 6M6 6l12 12',
  history: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01',
  procurement: 'M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z',
  stock: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
  finance: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  equity:      'M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z',
  equitySlice: 'M20.488 9H15V3.512A9.004 9.004 0 0120.488 9z',
  mwl:         'M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
  vendors: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
  expenses: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z',
  itemMaster: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
  studyReporting: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
  physician: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
  masterData: 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4',
  roles: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
  hr: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
  attendance: 'M9 11l3 3L22 4M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11',
  backup: 'M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4',
  aiSparkles: 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z',
  inbox: 'M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4',
  board: 'M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2',
  list: 'M4 6h16M4 10h16M4 14h16M4 18h16',
  target: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6',
  environment: 'M12 3v3m0 12v3m9-9h-3M6 12H3m14.95-6.95l-2.12 2.12M8.17 15.83l-2.12 2.12m0-12.9l2.12 2.12m7.66 7.66l2.12 2.12M12 8a4 4 0 100 8 4 4 0 000-8z',
  remote: 'M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
};

// ─── Navigation structure ──────────────────────────────────────────────────────
// permission: which permission is required to see this item (null = visible to all logged-in users)
const NAV_GROUPS = [
  {
    key: 'main',
    section: 'Main',
    items: [
      { to: '/dashboard', label: 'Dashboard', iconKey: 'dashboard', permission: 'DASHBOARD_VIEW' },
      { to: '/partner-dashboard', label: 'Dashboard',      iconKey: 'dashboard', partnerOnly: true },
      { to: '/reports',           label: 'Revenue Report', iconKey: 'reports',   partnerOnly: true },
    ],
  },
  {
    // Enquiries to confirmed appointments. One page (pages/Leads.jsx); each item is a view of it.
    key: 'sales',
    section: 'Sales & Leads',
    items: [
      { to: '/leads',                 label: 'My Calls',        iconKey: 'phone',    permission: ['LEAD_VIEW', 'LEAD_MANAGE'] },
      { to: '/leads?view=unassigned', label: 'Unassigned',      iconKey: 'inbox',    permission: ['LEAD_VIEW', 'LEAD_MANAGE'], badge: 'leadsUnassigned' },
      { to: '/leads?view=board',      label: 'Pipeline Board',  iconKey: 'board',    permission: ['LEAD_VIEW', 'LEAD_MANAGE'] },
      { to: '/leads?view=all',        label: 'All Leads',       iconKey: 'list',     permission: ['LEAD_VIEW', 'LEAD_MANAGE'] },
      { to: '/leads?view=team',       label: 'Team & Targets',  iconKey: 'target',   permission: 'LEAD_MANAGE' },
      { to: '/leads?view=reports',    label: 'Lead Reports',    iconKey: 'reports',  permission: 'LEAD_MANAGE' },
      { to: '/leads?view=settings',   label: 'Lead Settings',   iconKey: 'settings', iconKey2: 'settings2', permission: 'LEAD_MANAGE' },
    ],
  },
  {
    key: 'clinical',
    section: 'Clinical',
    items: [
      { to: '/appointments',          label: 'Appointments',          iconKey: 'calendar',      permission: 'APPOINTMENT_VIEW' },
      { to: '/patients',              label: 'Patient Reg & Billing', iconKey: 'users',         permission: 'PATIENT_VIEW' },
      { to: '/patient-history',       label: 'Patient History',       iconKey: 'history',       permission: 'PATIENT_VIEW' },
      { to: '/partner-patients',      label: 'Patient History',       iconKey: 'history',       partnerOnly: true },
      { to: '/study-reporting',       label: 'Worklist',              iconKey: 'studyReporting',permission: 'STUDY_VIEW' },
      { to: '/referring-physicians',  label: 'Ref. Physicians',       iconKey: 'physician',     permission: 'PHYSICIAN_VIEW' },
    ],
  },
  {
    key: 'finance',
    section: 'Finance',
    items: [
      { to: '/finance',       label: 'Finance Workspace', iconKey: 'finance',  permission: 'JE_VIEW' },
      { to: '/finance?tab=ap&sub=direct',   label: 'Vendor Bills',    iconKey: 'invoices', permission: ['JE_VIEW', 'VENDOR_WRITE'] },
      { to: '/finance?tab=ap&sub=payments', label: 'Vendor Payments', iconKey: 'finance',  permission: 'JE_VIEW' },
      { to: '/daily-cash-closing', label: 'Daily Cash Closing', iconKey: 'finance', permission: 'CASH_CLOSING_VIEW' },
      { to: '/petty-cash',    label: 'Cash Vouchers',     iconKey: 'expenses', permission: 'PETTY_CASH_VIEW' },
      { to: '/petty-cash-ap', label: 'Imprest Management', iconKey: 'finance',  permission: 'PETTY_CASH_APPROVE' },
      { to: '/equity',        label: 'Equity & Capital',  iconKey: 'equity', iconKey2: 'equitySlice', permission: 'EQUITY_VIEW' },
    ],
  },
  {
    key: 'hr',
    section: 'HRMS',
    items: [
      { to: '/employee-attendance', label: 'My Attendance', iconKey: 'attendance', permission: null },
      { to: '/hr', label: 'HR Management', iconKey: 'hr', permission: ['HR_DASHBOARD_VIEW','EMPLOYEE_VIEW','ATTENDANCE_VIEW','LEAVE_APPLY','LEAVE_APPROVE','PAYROLL_VIEW'] },
      { to: '/payroll', label: 'Payroll', iconKey: 'finance', permission: 'PAYROLL_VIEW' },
      { to: '/recruitment', label: 'Recruitment', iconKey: 'hr', permission: ['RECRUITMENT_VIEW','RECRUITMENT_WRITE','OFFER_APPROVE'] },
    ],
  },
  {
    key: 'operations',
    section: 'Operations',
    // Ordered by day-to-day relevance: the consumables chain first (stock ->
    // procurement -> AI assist -> item catalogue), then the asset pages, then
    // passive monitoring (its alerts reach the header bell anyway).
    items: [
      { to: '/stock',             label: 'Stock Management', iconKey: 'stock',      permission: 'INVENTORY_VIEW' },
      { to: '/procurement',       label: 'Procurement',      iconKey: 'procurement',permission: ['PR_VIEW','PO_VIEW','GRN_VIEW'] },
      { to: '/ai-material-management', label: 'AI Material Management', iconKey: 'aiSparkles', permission: 'AI_SCAN_USE' },
      { to: '/item-master',       label: 'Item Master',      iconKey: 'itemMaster', permission: 'INVENTORY_VIEW' },
      { to: '/assets',            label: 'Asset Management', iconKey: 'equipment',  permission: 'ASSET_VIEW' },
      { to: '/asset-maintenance', label: 'Asset Maintenance',iconKey: 'equipment',  permission: 'ASSET_MAINTENANCE_VIEW' },
      // Scanners (MWL) sidebar entry removed — not in active use. Route still
      // mounted in App.jsx so any direct link / bookmark continues to work,
      // and Settings → MWL Gateway covers the admin path.
      { to: '/environment-monitoring', label: 'Environment Monitoring', iconKey: 'environment', permission: 'IOT_MONITOR_VIEW' },
    ],
  },
  {
    key: 'remote',
    section: 'Remote Access',
    // Remote MRI console for people the super admin authorised (a per-user grant or an
    // approver tick, not a permission) and for super admins. The section disappears for
    // everyone else; Setup & Help only for people who operate the console (Control grant).
    items: [
      { to: '/remote-access',            label: 'Control',      iconKey: 'remote', permission: null, grantGated: 'remoteConsole' },
      { to: '/remote-access?view=setup', label: 'Setup & Help', iconKey: 'roles',  permission: null, grantGated: 'remoteConsoleSetup' },
    ],
  },
  {
    key: 'system',
    section: 'System',
    items: [
      { to: '/centers',        label: 'Centers',             iconKey: 'centers',                           permission: 'CENTER_VIEW' },
      { to: '/center-contracts', label: 'Center Contracts',  iconKey: 'finance',                           permission: 'CENTER_CONTRACT_VIEW' },
      { to: '/company-documents', label: 'Company Documents', iconKey: 'masterData',                       permission: ['COMPANY_DOC_VIEW','COMPANY_DOC_WRITE'] },
      { to: '/master-data',    label: 'Master Data',         iconKey: 'masterData',                        permission: ['MASTER_DATA_VIEW','RAD_REPORTING_MASTER_VIEW'] },
      { to: '/settings/users', label: 'User Management',     iconKey: 'users',                             permission: ['USER_VIEW','USER_WRITE'] },
      { to: '/settings/roles', label: 'Roles & Permissions', iconKey: 'roles',                             permission: ['USER_VIEW','USER_WRITE'] },
      { to: '/settings/mwl',   label: 'MWL Gateway',         iconKey: 'mwl',                               permission: 'MWL_VIEW' },
      { to: '/settings/remote-2fa', label: 'Console Settings', iconKey: 'remote',                        permission: 'ALL_ACCESS' }, // remote MRI console: Comet, connection & 2FA, users, log (tabs on the page)
      { to: '/settings',        label: 'Settings',            iconKey: 'settings', iconKey2: 'settings2',  permission: 'MASTER_DATA_VIEW' },
      { to: '/ai-tools-settings', label: 'AI Settings',       iconKey: 'settings', iconKey2: 'aiSparkles', permission: 'AI_SCAN_CONFIG' },
      { to: '/settings/audit', label: 'Audit Log',            iconKey: 'history',                           permission: ['USER_VIEW','USER_WRITE'] },
      { to: '/settings/backup', label: 'DB Backup',           iconKey: 'backup',                              permission: 'MASTER_DATA_VIEW' },
      { to: '/reports',        label: 'Reports',             iconKey: 'reports',                           permission: 'REPORTS_VIEW' },
    ],
  },
];

const NAV_PATHS = NAV_GROUPS.flatMap(group => group.items.map(item => item.to));
const NAV_ROUTE_PATHS = NAV_PATHS.map(path => path.split('?')[0]);
const collapsedStateForOpenGroup = (groups, openKey) =>
  groups.reduce((acc, group) => ({ ...acc, [group.key]: group.key !== openKey }), {});
const FINANCE_SHORTCUT_TITLES = {
  // (also the titles of other query-param sub-items, e.g. Remote Access)
  '/remote-access?view=setup': 'Setup & Help',
  '/settings/remote-2fa?tab=comet': 'Console Settings',
  '/settings/remote-2fa?tab=settings': 'Console Settings',
  '/settings/remote-2fa?tab=users': 'Console Settings',
  '/settings/remote-2fa?tab=log': 'Console Settings',
  '/finance?tab=ap&sub=direct': 'Vendor Bills',
  '/finance?tab=ap&sub=payments': 'Vendor Payments',
  '/reports?report=cash-imprest': 'Cash & Imprest Report',
};

const normalizeNavPath = (pathname, search = '') => {
  const params = new URLSearchParams(search || '');
  if (pathname === '/finance' && params.has('tab')) {
    const tab = params.get('tab');
    const sub = params.get('sub');
    return sub ? `/finance?tab=${tab}&sub=${sub}` : `/finance?tab=${tab}`;
  }
  // Only the lead views the sidebar lists; anything else on /leads is My Calls.
  if (pathname === '/leads') return params.get('view') ? `/leads?view=${params.get('view')}` : '/leads';
  if (pathname === '/reports' && params.has('report')) {
    return `/reports?report=${params.get('report')}`;
  }
  // Remote Access: the user page's views and the admin page's tabs are sidebar items.
  if (pathname === '/remote-access') return ['setup', 'help', 'activity'].includes(params.get('view')) ? '/remote-access?view=setup' : '/remote-access';
  if (pathname === '/settings/remote-2fa') return '/settings/remote-2fa'; // one sidebar item; the tabs live on the page
  return `${pathname}${search || ''}`;
};

const ROUTE_NAV_ANCHORS = {
  '/billing': '/patients',
  '/appointments': '/appointments',
  '/pid-management': '/patients',
  '/study-management': '/study-reporting',
  '/scanners': '/settings/mwl',
};

// Page title map for header
const PAGE_TITLES = {
  '/': 'Dashboard',
  '/dashboard': 'Dashboard',
  '/appointments': 'Appointments',
  '/leads': 'Patient Leads',
  '/settings/remote-2fa': 'Console Settings',
  '/remote-access': 'Control',
  '/patients': 'Patients',
  '/patient-history': 'Patient History',
  '/master-data': 'Master Data Settings',
  '/centers': 'Centers',
  '/center-contracts': 'Center Contracts',
  '/billing': 'Billing',
  '/scanners': 'Scanners',
  '/employee-attendance': 'My Attendance',
  '/hr': 'HR Management',
  '/payroll': 'Payroll',
  '/recruitment': 'Recruitment & Onboarding',
  '/company-documents': 'Company Documents',
  '/assets':            'Asset Management',
  '/asset-maintenance': 'Asset Maintenance',
  '/environment-monitoring': 'Environment Monitoring',
  '/procurement':       'Procurement',
  '/ai-material-management': 'AI Material Management',
  '/petty-cash':        'Cash Vouchers',
  '/petty-cash-ap':     'Imprest Management',
  '/stock':             'Stock Management',
  '/item-master':       'Item Master',
  '/study-reporting':   'Worklist',
  '/finance':           'Finance Workspace',
  '/daily-cash-closing': 'Daily Cash Closing',
  '/equity':            'Equity & Capital',
  '/vendors':           'Vendors',
  '/expenses':          'Expenses',
  '/pid-management':    'PID Management',
  '/study-management':  'Study Management',
  '/reports': 'Reports',
  '/settings':         'Settings',
  '/settings/users':   'User Management',
  '/settings/roles':   'Roles & Permissions',
  '/settings/mwl':     'DICOM MWL Gateway',
  '/settings/audit':   'Audit Log',
  '/settings/backup':  'DB Backup',
};

// ─── Change Password Modal ────────────────────────────────────────────────────
const ChangePasswordModal = ({ onClose }) => {
  const [form, setForm]     = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [err, setErr]       = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);
  const set = f => e => setForm(p => ({ ...p, [f]: e.target.value }));

  const submit = async ev => {
    ev.preventDefault();
    if (!form.currentPassword)                        { setErr('Current password is required'); return; }
    if (form.newPassword.length < 8)                  { setErr('New password must be at least 8 characters'); return; }
    if (form.newPassword !== form.confirmPassword)    { setErr('New passwords do not match'); return; }
    setSaving(true); setErr('');
    try {
      const token = localStorage.getItem('token');
      const r = await fetch('/api/auth/change-password', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ currentPassword: form.currentPassword, newPassword: form.newPassword }),
      });
      const d = await r.json();
      if (!r.ok) { setErr(d.error || 'Failed to change password'); setSaving(false); return; }
      setSuccess('Password changed successfully!');
      setTimeout(onClose, 1500);
    } catch { setErr('Network error'); setSaving(false); }
  };

  const fi = 'w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500';
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-white rounded-xl w-full max-w-sm shadow-xl">
        <div className="px-5 py-4 border-b border-slate-200 flex justify-between items-center">
          <h3 className="text-sm font-semibold text-slate-800">Change Password</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600 text-lg leading-none">✕</button>
        </div>
        <form onSubmit={submit} className="p-5 space-y-3">
          {err     && <p className="text-xs text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2">{err}</p>}
          {success && <p className="text-xs text-green-700 bg-green-50 border border-green-200 rounded px-3 py-2">{success}</p>}
          <div>
            <label className="block text-xs font-medium text-slate-600 mb-1">Current Password</label>
            <input type="password" value={form.currentPassword} onChange={set('currentPassword')} className={fi} autoFocus />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-600 mb-1">New Password <span className="text-slate-400">(min 8 characters)</span></label>
            <input type="password" value={form.newPassword} onChange={set('newPassword')} className={fi} />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-600 mb-1">Confirm New Password</label>
            <input type="password" value={form.confirmPassword} onChange={set('confirmPassword')} className={fi} />
          </div>
          <div className="flex justify-end gap-2 pt-1">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm text-slate-600 bg-slate-100 rounded-lg hover:bg-slate-200">Cancel</button>
            <button type="submit" disabled={saving} className="px-4 py-2 text-sm text-white bg-teal-600 rounded-lg hover:bg-teal-700 disabled:opacity-50">
              {saving ? 'Saving…' : 'Change Password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ─── Header logo (top-right corner) ──────────────────────────────────────────
const HeaderLogo = () => {
  const [logoConfig, setLogoConfig] = React.useState(() => {
    try { return JSON.parse(localStorage.getItem('logoConfig')) || {}; } catch { return {}; }
  });
  React.useEffect(() => {
    const load = () => {
      try { setLogoConfig(JSON.parse(localStorage.getItem('logoConfig')) || {}); } catch {}
    };
    window.addEventListener('logoConfigUpdated', load);
    window.addEventListener('storage', e => { if (e.key === 'logoConfig') load(); });
    return () => {
      window.removeEventListener('logoConfigUpdated', load);
      window.removeEventListener('storage', load);
    };
  }, []);

  if (!logoConfig.customLogo) return null;
  return (
    <img
      src={logoConfig.customLogo}
      alt="ARIS Logo"
      style={{ height: '50px', width: 'auto', display: 'block' }}
    />
  );
};

// ─── Sidebar brand text ───────────────────────────────────────────────────────
const SidebarLogo = ({ collapsed }) => (
  <div style={{
    flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
    height: 64, borderBottom: '1px solid rgba(45,212,191,0.12)',
  }}>
    {collapsed ? (
      <span style={{ fontFamily: "'Cinzel', serif", color: '#fbbf24', fontWeight: 700, fontSize: '1.1rem', letterSpacing: '0.05em' }}>A</span>
    ) : (
      <span style={{
        fontFamily: "'Cinzel', serif",
        color: '#fbbf24',
        fontWeight: 700,
        fontSize: '1.25rem',
        letterSpacing: '0.22em',
        textShadow: '0 0 18px rgba(251,191,36,0.35), 0 1px 3px rgba(0,0,0,0.4)',
      }}>
        ARIS ERP
      </span>
    )}
  </div>
);

// ─── Main Layout ──────────────────────────────────────────────────────────────
const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Desktop sidebar collapsed state
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try { return localStorage.getItem('aris_sidebar_collapsed') === 'true'; } catch { return false; }
  });

  // Mobile sidebar open state
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [sidebarSearch, setSidebarSearch] = useState('');
  const [searchArmed, setSearchArmed] = useState(false);
  // A browser or password manager that fills the login e-mail / username into
  // the menu search hides every menu item. Such a value is never a menu search.
  const looksAutofilled = (v) => {
    const t = String(v || '').trim().toLowerCase();
    if (!t) return false;
    if (t.includes('@')) return true;
    const own = [user?.email, user?.username].filter(Boolean).map(x => String(x).toLowerCase());
    return own.includes(t);
  };

  // Profile popover & change password
  const [showProfile, setShowProfile]             = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [aiScanEnabled, setAiScanEnabled] = useState(null);
  // MRI Remote Console: a per-user grant decides, so ask the server once (super admins always see it).
  const [remoteConsole, setRemoteConsole] = useState(() => {
    try { return (JSON.parse(localStorage.getItem('user'))?.permissions || []).includes('ALL_ACCESS'); } catch { return false; }
  });
  const [remoteConsoleSetup, setRemoteConsoleSetup] = useState(remoteConsole); // a Control grant somewhere (or super admin)

  // Header notification bell: environment alarms + document renewals
  const [showNotif, setShowNotif] = useState(false);
  const approvalInbox = useApprovalInbox(showNotif, location.key);
  const [notifDocs, setNotifDocs] = useState([]);
  const [navBadges, setNavBadges] = useState({}); // counts shown beside sidebar items

  const [envAlerts, setEnvAlerts] = useState([]);

  // Nav group collapse states
  const [collapsedGroups, setCollapsedGroups] = useState(() => {
    try {
      const saved = localStorage.getItem('aris_nav_groups');
      return saved ? JSON.parse(saved) : {};
    } catch { return {}; }
  });

  // User info — loaded from localStorage (permissions are fetched from DB at login time)
  const [user] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')) || {}; } catch { return {}; }
  });

  // Permission check — ALL_ACCESS bypasses everything (SUPER_ADMIN)
  // perm can be a string or array of strings (any match = allowed)
  const hasPermission = (perm) => {
    if (!perm) return true;
    const perms = Array.isArray(user.permissions) ? user.permissions : [];
    if (perms.includes('ALL_ACCESS')) return true;
    const required = Array.isArray(perm) ? perm : [perm];
    return required.some(p => perms.includes(p));
  };

  useEffect(() => {
    if (!hasPermission('AI_SCAN_USE')) {
      setAiScanEnabled(false);
      return;
    }
    let alive = true;
    const token = localStorage.getItem('token');
    fetch('/api/ai-scan/status', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (alive && d?.success) setAiScanEnabled(!!d.enabled); })
      .catch(() => {});
    return () => { alive = false; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (remoteConsole) return undefined;
    let alive = true;
    fetch('/api/remote-access/mine', { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (alive && d?.success) { const cs = d.consoles || []; setRemoteConsole(cs.length > 0); setRemoteConsoleSetup(cs.some(c => c.access_level === 'CONTROL')); } })
      .catch(() => {});
    return () => { alive = false; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Active environment alarms (IoT sensors) -> header notification bell.
  // Polled every 60s so a room breach reaches the header without a reload.
  useEffect(() => {
    if (!hasPermission(['IOT_MONITOR_VIEW', 'IOT_MONITOR_MANAGE'])) return undefined;
    let alive = true;
    const loadAlerts = () => {
      const token = localStorage.getItem('token');
      fetch('/api/iot-monitoring/alerts?status=ACTIVE', { headers: { Authorization: `Bearer ${token}` } })
        .then(r => (r.ok ? r.json() : null))
        .then(d => { if (alive && d?.success && Array.isArray(d.alerts)) setEnvAlerts(d.alerts); })
        .catch(() => {});
    };
    loadAlerts();
    const timer = setInterval(loadAlerts, 60000);
    const onFocus = () => loadAlerts();
    window.addEventListener('focus', onFocus);
    return () => { alive = false; clearInterval(timer); window.removeEventListener('focus', onFocus); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Expiring / expired company documents → header notification bell.
  // Authorized users only; backend already centre-scopes the result and returns
  // expired/expiring_soon flags. ?expiring=60 includes already-expired docs too.
  useEffect(() => {
    if (!hasPermission(['COMPANY_DOC_VIEW', 'COMPANY_DOC_WRITE'])) return undefined;
    let alive = true;
    const loadNotif = () => {
      const token = localStorage.getItem('token');
      fetch('/api/company-documents?expiring=60', { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.ok ? r.json() : null)
        .then(d => { if (alive && d?.success && Array.isArray(d.documents)) setNotifDocs(d.documents); })
        .catch(() => {});
    };
    loadNotif();
    // Refetch when the Company Documents page reports an upload/delete (keeps the badge fresh).
    window.addEventListener('aris:company-docs-changed', loadNotif);
    return () => { alive = false; window.removeEventListener('aris:company-docs-changed', loadNotif); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Unassigned enquiries, beside the sidebar item. The leads page reports the
  // number whenever it reloads; otherwise a light count is fetched here every two minutes.
  useEffect(() => {
    if (!hasPermission(['LEAD_VIEW', 'LEAD_MANAGE'])) return undefined;
    const token = localStorage.getItem('token');
    let alive = true;
    const load = () => fetch('/api/leads/unassigned-count', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (alive && d?.success) setNavBadges(b => ({ ...b, leadsUnassigned: Number(d.unassigned) || 0 })); })
      .catch(() => {});
    const onSummary = e => setNavBadges(b => ({ ...b, leadsUnassigned: Number(e.detail?.unassigned) || 0 }));
    load();
    const timer = setInterval(load, 120000);
    window.addEventListener('aris:leads-summary', onSummary);
    return () => { alive = false; clearInterval(timer); window.removeEventListener('aris:leads-summary', onSummary); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Filtered nav groups — hide items the user has no permission for,
  // and hide entire sections if all their items are hidden
  // A revenue-share partner (e.g. NS Hospital): PARTNER_VIEW only, no general dashboard/admin
  // access. They see ONLY their partner items (dashboard + revenue report); everyone else never
  // sees partner items.
  const navPerms = Array.isArray(user.permissions) ? user.permissions : [];
  // Keep this definition in sync with isPurePartner() in pages/Reports.jsx.
  const isPurePartner = navPerms.includes('PARTNER_VIEW')
    && !navPerms.includes('ALL_ACCESS')
    && !navPerms.includes('REPORTS_VIEW')
    && !navPerms.includes('DASHBOARD_VIEW');

  const visibleNavGroups = useMemo(() => NAV_GROUPS.map(group => ({
    ...group,
    items: group.items.filter(item => {
      if (item.partnerOnly) return isPurePartner;
      if (isPurePartner) return false;
      if (!hasPermission(item.permission)) return false;
      if (item.to === '/ai-material-management' && aiScanEnabled === false) return false;
      if (item.grantGated === 'remoteConsole' && !remoteConsole) return false;
      if (item.grantGated === 'remoteConsoleSetup' && !remoteConsoleSetup) return false;
      return true;
    }),
  })).filter(group => group.items.length > 0), [aiScanEnabled, remoteConsole, remoteConsoleSetup, isPurePartner, user.permissions]);
  const sidebarQuery = sidebarSearch.trim().toLowerCase();
  const displayedNavGroups = useMemo(() => {
    if (!sidebarQuery) return visibleNavGroups;
    return visibleNavGroups
      .map(group => ({
        ...group,
        items: group.items.filter(item =>
          item.label.toLowerCase().includes(sidebarQuery)
          || group.section.toLowerCase().includes(sidebarQuery)
        ),
      }))
      .filter(group => group.items.length > 0);
  }, [sidebarQuery, visibleNavGroups]);

  // Persist sidebar collapse
  useEffect(() => {
    try { localStorage.setItem('aris_sidebar_collapsed', sidebarCollapsed); } catch {}
  }, [sidebarCollapsed]);

  // Persist group collapse states
  useEffect(() => {
    try { localStorage.setItem('aris_nav_groups', JSON.stringify(collapsedGroups)); } catch {}
  }, [collapsedGroups]);

  const getActiveNavPath = useCallback((pathname, search = '') => {
    const fullPath = normalizeNavPath(pathname, search);
    if (NAV_PATHS.includes(fullPath)) return fullPath;
    if (pathname === '/') return '/dashboard';
    if (ROUTE_NAV_ANCHORS[pathname]) return ROUTE_NAV_ANCHORS[pathname];
    if (NAV_ROUTE_PATHS.includes(pathname)) return pathname;
    return NAV_ROUTE_PATHS
      .filter(path => pathname.startsWith(`${path}/`))
      .sort((a, b) => b.length - a.length)[0] || pathname;
  }, []);

  const activeNavPath = getActiveNavPath(location.pathname, location.search);

  // Close mobile sidebar and profile popover on route change
  useEffect(() => {
    setMobileSidebarOpen(false);
    setShowProfile(false);
    setShowNotif(false);
  }, [location.pathname, location.search]);

  // Keep only the active sidebar section open so users do not lose their place
  // in a long enterprise menu.
  useEffect(() => {
    if (sidebarQuery) return;
    const activeGroup = visibleNavGroups.find(group =>
      group.items.some(item => item.to === activeNavPath)
    );
    if (!activeGroup) return;
    setCollapsedGroups(prev => {
      const next = collapsedStateForOpenGroup(visibleNavGroups, activeGroup.key);
      return JSON.stringify(prev) === JSON.stringify(next) ? prev : next;
    });
  }, [activeNavPath, sidebarQuery, visibleNavGroups]);

  const handleLogout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  }, [navigate]);

  const isActive = useCallback((to) => {
    return activeNavPath === to;
  }, [activeNavPath]);

  const revealActiveSidebarItem = useCallback(() => {
    window.requestAnimationFrame(() => {
      const activeItem = document.querySelector('[data-active-nav="true"]');
      activeItem?.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
    });
  }, []);

  // Keep the anchored sidebar menu visible after navigation, deep links, and
  // page refocus/clicks when the user has manually scrolled the sidebar.
  useEffect(() => {
    const timeout = window.setTimeout(revealActiveSidebarItem, 80);
    return () => window.clearTimeout(timeout);
  }, [activeNavPath, sidebarCollapsed, collapsedGroups, revealActiveSidebarItem]);

  const toggleGroup = useCallback((key) => {
    setCollapsedGroups(collapsedStateForOpenGroup(visibleNavGroups, key));
  }, [visibleNavGroups]);

  const pageTitle = FINANCE_SHORTCUT_TITLES[normalizeNavPath(location.pathname, location.search)] || PAGE_TITLES[location.pathname] || 'ARIS ERP';

  // Get user initials
  const getInitials = (u) => {
    const name = u.name || u.username || u.email || 'A';
    return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
  };

  // ── Sidebar content (shared between desktop + mobile) ──
  const renderSidebarContent = (isMobile = false) => (
    <div className="flex flex-col h-full" style={{ background: '#0d3330' }}>
      {/* Logo / Brand */}
      <SidebarLogo collapsed={!isMobile && sidebarCollapsed} />

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-3 no-scrollbar" style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>
        {(isMobile || !sidebarCollapsed) && (
          <div style={{ padding: '0 10px 10px' }}>
            <div style={{
              display: 'flex', alignItems: 'center', gap: 8,
              padding: '8px 10px',
              borderRadius: 9,
              background: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(94,234,212,0.12)',
            }}>
              <Icon d={icons.search} className="w-4 h-4" />
              <input
                type="search"
                name="aris-menu-filter"
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck={false}
                data-lpignore="true"
                data-1p-ignore="true"
                data-form-type="other"
                value={sidebarSearch}
                onChange={e => setSidebarSearch(looksAutofilled(e.target.value) ? '' : e.target.value)}
                // Password managers skip read-only fields; it becomes editable the moment it is tapped.
                readOnly={!searchArmed}
                onFocus={() => setSearchArmed(true)}
                onBlur={() => { if (!sidebarSearch) setSearchArmed(false); }}
                placeholder="Search menu..."
                aria-label="Search menu"
                style={{
                  flex: 1,
                  minWidth: 0,
                  height: 18,   // opt out of the global 38px control height — this input lives inside a padded pill
                  background: 'transparent',
                  border: 0,
                  outline: 'none',
                  color: '#ccfbf1',
                  fontSize: '0.78rem',
                  fontWeight: 500,
                }}
              />
              {sidebarSearch && (
                <button
                  type="button"
                  onClick={() => setSidebarSearch('')}
                  title="Clear search"
                  aria-label="Clear menu search"
                  style={{
                    color: '#7ecdc8',
                    border: 0,
                    background: 'transparent',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    lineHeight: 1,
                  }}
                >
                  ×
                </button>
              )}
            </div>
          </div>
        )}

        {displayedNavGroups.length === 0 && (isMobile || !sidebarCollapsed) && (
          <div style={{
            margin: '8px 12px',
            padding: '12px',
            color: '#7ecdc8',
            fontSize: '0.78rem',
            textAlign: 'center',
            border: '1px dashed rgba(94,234,212,0.18)',
            borderRadius: 9,
          }}>
            No menu matches “{sidebarSearch.trim().slice(0, 40)}”
            <button type="button" onClick={() => setSidebarSearch('')}
              style={{ display: 'block', margin: '8px auto 0', background: 'rgba(45,212,191,0.15)', color: '#ccfbf1', border: '1px solid rgba(94,234,212,0.4)', borderRadius: 6, padding: '4px 12px', fontSize: '0.75rem', fontWeight: 600, cursor: 'pointer' }}>
              Clear search
            </button>
          </div>
        )}

        {displayedNavGroups.map((group) => {
          const groupCollapsed = sidebarQuery ? false : collapsedGroups[group.key];
          const showLabel = isMobile || !sidebarCollapsed;

          return (
            <div key={group.key} style={{ marginBottom: 4 }}>
              {/* Section header */}
              {showLabel && (
                <button
                  onClick={() => toggleGroup(group.key)}
                  style={{
                    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '10px 14px 5px',
                    fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.1em',
                    textTransform: 'uppercase', color: '#5eead4',
                    background: 'none', border: 'none', cursor: 'pointer',
                    transition: 'color 0.15s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.color = '#99f6e4'}
                  onMouseLeave={e => e.currentTarget.style.color = '#5eead4'}
                >
                  <span>{group.section}</span>
                  <Icon
                    d={groupCollapsed ? icons.chevronRight : icons.chevronDown}
                    className="w-3 h-3 transition-transform duration-200"
                  />
                </button>
              )}

              {/* Nav items */}
              <div className={`overflow-hidden transition-all duration-200 ${groupCollapsed && showLabel ? 'max-h-0' : 'max-h-screen'}`}>
                {group.items.map((item) => {
                  const active = isActive(item.to);
                  return (
                    <Link
                      key={item.to}
                      to={item.to}
                      data-active-nav={active ? 'true' : undefined}
                      aria-current={active ? 'page' : undefined}
                      title={!showLabel ? item.label : undefined}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: showLabel ? 'flex-start' : 'center',
                        margin: '1px 8px',
                        padding: showLabel ? '8px 10px' : '8px 0',
                        borderRadius: 8,
                        fontSize: '0.78rem',
                        fontWeight: active ? 600 : 500,
                        letterSpacing: '0.01em',
                        textDecoration: 'none',
                        transition: 'all 0.15s',
                        position: 'relative',
                        background: active ? 'rgba(20,184,166,0.18)' : 'transparent',
                        color: active ? '#ccfbf1' : '#7ecdc8',
                        borderLeft: active ? '2px solid #2dd4bf' : '2px solid transparent',
                      }}
                      onMouseEnter={e => {
                        if (!active) {
                          e.currentTarget.style.background = 'rgba(45,212,191,0.08)';
                          e.currentTarget.style.color = '#ccfbf1';
                        }
                      }}
                      onMouseLeave={e => {
                        if (!active) {
                          e.currentTarget.style.background = 'transparent';
                          e.currentTarget.style.color = '#7ecdc8';
                        }
                      }}
                    >
                      {/* Icon */}
                      <span style={{
                        flexShrink: 0,
                        color: active ? '#5eead4' : '#3d8c87',
                        display: 'flex', alignItems: 'center',
                      }}>
                        {item.iconKey2 ? (
                          <Icon d={icons[item.iconKey]} d2={icons[item.iconKey2]} className="w-[17px] h-[17px]" />
                        ) : (
                          <Icon d={icons[item.iconKey]} className="w-[17px] h-[17px]" />
                        )}
                      </span>
                      {/* Label */}
                      {showLabel && (
                        <span style={{ marginLeft: 10, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {item.label}
                        </span>
                      )}
                      {/* Count waiting (e.g. unassigned enquiries) */}
                      {item.badge && navBadges[item.badge] > 0 && (
                        <span aria-label={`${navBadges[item.badge]} waiting`} style={showLabel
                          ? { marginLeft: 6, flexShrink: 0, minWidth: 18, padding: '0 5px', borderRadius: 9, background: '#dc2626', color: '#fff', fontSize: '0.66rem', fontWeight: 700, lineHeight: '18px', textAlign: 'center' }
                          : { position: 'absolute', top: 3, right: 8, width: 8, height: 8, borderRadius: '50%', background: '#dc2626' }}>
                          {showLabel ? navBadges[item.badge] : ''}
                        </span>
                      )}
                      {/* Active dot */}
                      {active && showLabel && !(item.badge && navBadges[item.badge] > 0) && (
                        <span style={{
                          marginLeft: 'auto', flexShrink: 0,
                          width: 5, height: 5, borderRadius: '50%',
                          background: '#2dd4bf',
                          boxShadow: '0 0 6px #2dd4bf',
                        }} />
                      )}
                    </Link>
                  );
                })}
              </div>

              {/* Divider in collapsed (mini) mode */}
              {!showLabel && (
                <div style={{ margin: '6px 10px', borderTop: '1px solid rgba(255,255,255,0.06)' }} />
              )}
            </div>
          );
        })}
      </nav>

    </div>
  );

  return (
    <>
      <div className="app-shell flex h-screen bg-slate-50 overflow-hidden">

        {/* ── Desktop Sidebar ─────────────────────────────────────────────────── */}
        <div
          className={`hidden md:flex flex-shrink-0 flex-col transition-all duration-300 ease-in-out ${
            sidebarCollapsed ? 'w-16' : 'w-60'
          }`}
        >
          {renderSidebarContent(false)}
        </div>

        {/* ── Mobile Sidebar Overlay ──────────────────────────────────────────── */}
        {mobileSidebarOpen && (
          <div className="fixed inset-0 z-40 md:hidden">
            {/* Backdrop */}
            <div
              className="fixed inset-0 bg-black bg-opacity-60 transition-opacity"
              onClick={() => setMobileSidebarOpen(false)}
              aria-hidden="true"
            />
            {/* Drawer */}
            <div className="app-drawer relative flex flex-col w-64 h-full shadow-2xl transform transition-transform duration-300">
              {/* Close button */}
              <button
                onClick={() => setMobileSidebarOpen(false)}
                className="absolute top-3 right-3 z-10 p-1.5 text-teal-400 hover:text-white hover:bg-teal-700 rounded-lg transition-colors"
              >
                <Icon d={icons.close} className="w-5 h-5" />
              </button>
              {renderSidebarContent(true)}
            </div>
          </div>
        )}

        {/* ── Main content area ───────────────────────────────────────────────── */}
        <div className="flex flex-col flex-1 min-w-0 overflow-hidden">

          {/* Top Header Bar */}
          <header className="flex-shrink-0 flex items-center h-16 bg-white border-b border-slate-200 px-4 shadow-sm">
            {/* Left: hamburger (mobile) + collapse toggle (desktop) + breadcrumb */}
            <div className="flex items-center gap-3 flex-1 min-w-0">
              {/* Mobile hamburger */}
              <button
                onClick={() => setMobileSidebarOpen(true)}
                className="md:hidden p-1.5 text-slate-500 hover:text-teal-700 hover:bg-teal-50 rounded-lg transition-colors"
                aria-label="Open sidebar"
              >
                <Icon d={icons.menu} className="w-5 h-5" />
              </button>

              {/* Desktop collapse toggle */}
              <button
                onClick={() => setSidebarCollapsed(c => !c)}
                className="hidden md:flex p-1.5 text-slate-500 hover:text-teal-700 hover:bg-teal-50 rounded-lg transition-colors"
                aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              >
                <Icon d={sidebarCollapsed ? icons.chevronRight : icons.chevronLeft} className="w-5 h-5" />
              </button>

              {/* Page title */}
              <span className="text-sm font-semibold text-slate-800 truncate">{pageTitle}</span>
            </div>

            {/* Right: account controls + settings + logo */}
            <div className="flex items-center gap-2 flex-shrink-0">
              <div className="relative flex items-center gap-2">
                {(() => {
                  const hasCritical = envAlerts.some(a => a.severity === 'CRITICAL') || notifDocs.some(d => d.expired);
                  const notifCount = envAlerts.length + notifDocs.length + approvalInbox.total;
                  const timeAgo = (ts) => {
                    if (!ts) return '';
                    const mins = Math.max(0, Math.round((Date.now() - new Date(ts).getTime()) / 60000));
                    if (mins < 1) return 'just now';
                    if (mins < 60) return `${mins}m ago`;
                    const hrs = Math.round(mins / 60);
                    if (hrs < 24) return `${hrs}h ago`;
                    return `${Math.round(hrs / 24)}d ago`;
                  };
                  return (
                  <div className="relative">
                    <button
                      onClick={() => setShowNotif(p => !p)}
                      title="Notifications"
                      aria-label={`Notifications, ${approvalInbox.total} pending approvals`} aria-expanded={showNotif}
                      className={`relative p-2 rounded-lg transition-colors ${showNotif ? 'bg-teal-50 text-teal-700' : 'text-slate-500 hover:text-teal-700 hover:bg-teal-50'}`}
                    >
                      <Icon d={icons.bell} className="w-5 h-5" />
                      {notifCount > 0 && (
                        <span className={`absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 flex items-center justify-center rounded-full text-[10px] font-bold text-white ${hasCritical ? 'bg-rose-600' : 'bg-amber-500'}`}>
                          {notifCount > 9 ? '9+' : notifCount}
                        </span>
                      )}
                    </button>
                    {/* Mobile: full-width sheet fixed under the header (an anchored
                        popover bleeds off-screen on small viewports). Desktop: the
                        same markup as an anchored dropdown. */}
                    {showNotif && (
                      <div className="fixed sm:absolute left-3 right-3 sm:left-auto sm:right-0 top-16 sm:top-full sm:mt-1 sm:w-96 sm:max-w-[calc(100vw-2rem)] bg-white rounded-2xl sm:rounded-xl shadow-2xl sm:shadow-xl border border-slate-200 overflow-hidden z-50">
                        <div className="px-4 py-3 bg-slate-900 flex items-center justify-between">
                          <p className="text-sm font-semibold text-white">Notifications</p>
                          <div className="flex items-center gap-3">
                            <span className="text-[11px] text-slate-300">{notifCount ? `${notifCount} item${notifCount === 1 ? '' : 's'}` : approvalInbox.error ? 'Refresh needed' : approvalInbox.loading ? 'Checking…' : 'All clear'}</span>
                            <button
                              onClick={() => setShowNotif(false)}
                              aria-label="Close notifications"
                              className="sm:hidden -mr-1 p-1.5 rounded-lg text-slate-300 hover:text-white hover:bg-white/10"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div className="max-h-[calc(100dvh-9.5rem)] sm:max-h-[min(70vh,32rem)] overflow-y-auto overscroll-contain">
                          {notifCount === 0 && !approvalInbox.loading && !approvalInbox.error && (
                            <p className="px-4 py-8 text-center text-sm text-slate-400">You&apos;re all caught up</p>
                          )}
                          <ApprovalNotifications inbox={approvalInbox} onOpen={url => { setShowNotif(false); navigate(url); }} />
                          {envAlerts.length > 0 && (
                            <div>
                              <div className="flex items-center justify-between px-4 pt-3 pb-1.5">
                                <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400">Environment</p>
                                <button onClick={() => { setShowNotif(false); navigate('/environment-monitoring'); }}
                                  className="text-[11px] font-semibold text-teal-700 hover:text-teal-800">Open monitor</button>
                              </div>
                              <div className="divide-y divide-slate-50">
                                {envAlerts.map(a => (
                                  <button key={`env-${a.id}`}
                                    onClick={() => { setShowNotif(false); navigate('/environment-monitoring'); }}
                                    className="w-full text-left px-4 py-3 sm:py-2.5 hover:bg-slate-50 active:bg-slate-100 transition-colors">
                                    <div className="flex items-start gap-2.5">
                                      <span className={`mt-1 h-2 w-2 flex-shrink-0 rounded-full ${a.severity === 'CRITICAL' ? 'bg-rose-500' : 'bg-amber-400'}`} aria-hidden="true" />
                                      <div className="min-w-0 flex-1">
                                        <div className="flex items-start justify-between gap-2">
                                          <p className="text-sm font-medium text-slate-800 truncate">{a.device_name}</p>
                                          <span className={`flex-shrink-0 text-[10px] font-semibold px-1.5 py-0.5 rounded ${a.severity === 'CRITICAL' ? 'bg-rose-100 text-rose-700' : 'bg-amber-100 text-amber-700'}`}>
                                            {a.severity === 'CRITICAL' ? 'Critical' : 'Warning'}
                                          </span>
                                        </div>
                                        <p className="text-[11px] text-slate-500 mt-0.5 truncate">{a.message}</p>
                                        <p className="text-[11px] text-slate-400 mt-0.5">{a.area_name}{a.center_name ? ` · ${a.center_name}` : ''} · {timeAgo(a.triggered_at)}</p>
                                      </div>
                                    </div>
                                  </button>
                                ))}
                              </div>
                            </div>
                          )}
                          {notifDocs.length > 0 && (
                            <div>
                              <div className="flex items-center justify-between px-4 pt-3 pb-1.5 border-t border-slate-100">
                                <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400">Document Renewals</p>
                                <button onClick={() => { setShowNotif(false); navigate('/company-documents?expiring=60'); }}
                                  className="text-[11px] font-semibold text-teal-700 hover:text-teal-800">View all</button>
                              </div>
                              <div className="divide-y divide-slate-50">
                                {notifDocs.map(d => {
                                  const tag = d.expired
                                    ? { t: 'Expired', c: 'bg-rose-100 text-rose-700', dot: 'bg-rose-500' }
                                    : d.expiring_soon
                                      ? { t: 'Due soon', c: 'bg-amber-100 text-amber-700', dot: 'bg-amber-400' }
                                      : { t: 'Upcoming', c: 'bg-slate-100 text-slate-600', dot: 'bg-slate-300' };
                                  return (
                                    <button
                                      key={`doc-${d.id}`}
                                      onClick={() => { setShowNotif(false); navigate('/company-documents?expiring=60'); }}
                                      className="w-full text-left px-4 py-3 sm:py-2.5 hover:bg-slate-50 active:bg-slate-100 transition-colors"
                                    >
                                      <div className="flex items-start gap-2.5">
                                        <span className={`mt-1 h-2 w-2 flex-shrink-0 rounded-full ${tag.dot}`} aria-hidden="true" />
                                        <div className="min-w-0 flex-1">
                                          <div className="flex items-start justify-between gap-2">
                                            <p className="text-sm font-medium text-slate-800 truncate">{d.title}</p>
                                            <span className={`flex-shrink-0 text-[10px] font-semibold px-1.5 py-0.5 rounded ${tag.c}`}>{tag.t}</span>
                                          </div>
                                          <p className="text-[11px] text-slate-500 mt-0.5 truncate">
                                            {d.category}{d.center_name ? ` · ${d.center_name}` : ' · Company-wide'} · Expires {String(d.expiry_date).slice(0, 10)}
                                          </p>
                                        </div>
                                      </div>
                                    </button>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  );
                })()}
                <div className="flex min-w-0 items-center gap-2 sm:gap-2.5 pr-2 sm:pr-3 mr-1 border-r border-slate-200">
                  <button
                    onClick={() => setShowProfile(p => !p)}
                    title="Account Menu"
                    aria-label="Account Menu"
                    className={`flex min-w-0 items-center gap-2 rounded-lg px-1.5 py-1 transition-colors focus:outline-none focus:ring-2 focus:ring-teal-200 ${showProfile ? 'bg-teal-50' : 'hover:bg-slate-50'}`}
                  >
                    <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-teal-700 text-xs font-bold tracking-wide text-white shadow-sm">
                      {getInitials(user)}
                    </div>
                    <div className="hidden sm:block min-w-0 max-w-[120px] lg:max-w-[150px] xl:max-w-[180px] text-left">
                      <p className="truncate text-xs font-semibold leading-4 text-slate-800">
                        {user.name || user.username || user.email || 'Admin'}
                      </p>
                      <p className="truncate text-[11px] leading-4 capitalize text-slate-500">
                        {user.role || 'Administrator'}
                      </p>
                    </div>
                  </button>
                  <button
                    onClick={handleLogout}
                    title="Sign out"
                    aria-label="Sign out"
                    className="flex h-9 min-w-9 flex-shrink-0 items-center justify-center gap-1.5 rounded-lg px-2.5 text-sm font-medium text-slate-600 transition-colors hover:bg-rose-50 hover:text-rose-600 focus:outline-none focus:ring-2 focus:ring-rose-200"
                  >
                    <Icon d={icons.logout} className="w-4 h-4" />
                    <span className="hidden lg:inline">Logout</span>
                  </button>
                </div>
                <button
                  onClick={() => setShowProfile(p => !p)}
                  title="Profile & Settings"
                  className={`p-2 rounded-lg transition-colors ${showProfile ? 'bg-teal-50 text-teal-700' : 'text-slate-500 hover:text-teal-700 hover:bg-teal-50'}`}
                >
                  <Icon d={icons.settings} d2={icons.settings2} className="w-5 h-5" />
                </button>
                {showProfile && (
                  <div className="absolute right-0 top-full mt-1 w-56 bg-white rounded-xl shadow-xl border border-slate-200 overflow-hidden z-50">
                    <div className="px-4 py-3 bg-gradient-to-r from-teal-600 to-teal-500">
                      <p className="text-sm font-semibold text-white truncate">{user.name || user.username || user.email || 'Admin'}</p>
                      <p className="text-xs text-teal-100 capitalize">{user.role || 'Administrator'}</p>
                    </div>
                    <div className="p-1">
                      <button
                        onClick={() => { setShowProfile(false); setShowChangePassword(true); }}
                        className="w-full flex items-center gap-2 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 rounded-lg transition-colors"
                      >
                        <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                        </svg>
                        Change Password
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <HeaderLogo />
            </div>
          </header>

          {/* Page content */}
          <main
            className="flex-1 overflow-y-auto bg-slate-50"
            onClick={revealActiveSidebarItem}
            onFocus={revealActiveSidebarItem}
          >
            <Outlet />
          </main>
        </div>

      </div>

      {/* Close profile popover on outside click — rendered outside overflow-hidden container */}
      {showProfile && (
        <div className="fixed inset-0 z-40" onClick={() => setShowProfile(false)} />
      )}

      {/* Close notification popover on outside click; dimmed on mobile so the
          sheet reads as a layer above the page, invisible on desktop */}
      {showNotif && (
        <div className="fixed inset-0 z-40 bg-slate-900/40 sm:bg-transparent" onClick={() => setShowNotif(false)} />
      )}

      {/* Change Password Modal — rendered outside overflow-hidden container */}
      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}
    </>
  );
};

export default Layout;
